import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./Modal.css";
export default ({
  showModal,
  closeModal,
  processingTransections,
  handlePlotSelection,
}) => {
  const handleProcessingClick = (index) => (e) => {
    handlePlotSelection(processingTransections[index]);
  };
  useEffect(() => {
    if (processingTransections?.length == 0) {
      closeModal();
    }
  }, [processingTransections]);
  return (
    <>
      <Modal
        show={showModal}
        backdropClassName="z-index-1"
        dialogClassName="modal-dialog modal-dialog-centered modal-lg"
        contentClassName={"modal-content customPopup transaction"}
      >
        <div>
          <button
            type="button"
            className="close"
            onClick={closeModal}
            aria-label="Close"
          >
            {/* <img src={close} alt="close-modal" /> */}
          </button>

          <div className="content">
            <div className="modal-caption text-center">
              <h2 className="title title-lg fw--700">Your Transaction(s)</h2>
            </div>

            <ul className="transactionList customScroll">
              {processingTransections?.map((plot, index) => (
                <li
                  key={plot.plot_id || plot.id}
                  onClick={handleProcessingClick(index)}
                >
                  <label htmlFor="" className="cursor-pointer truncate">
                    {plot.plot_name ?? plot.name ?? ""}
                  </label>
                  <div className="status inprogress cursor-pointer">
                    {plot?.status ?? ""}
                  </div>
                </li>
              ))}
            </ul>

            <div className="mobile-btn">
              <button onClick={closeModal} className="custom-btn gray-bg lg">
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
